import { toast as sonnerToast, Toaster as SonnerToaster } from "sonner";
import type { ComponentProps } from "react";

/**
 * Thin typed wrapper around Sonner so the rest of the codebase talks
 * to our shape only. Swap the underlying library one day → touch this
 * file only.
 */

type ToastOptions = Parameters<typeof sonnerToast.success>[1];

export const toast = {
  success(message: string, opts?: ToastOptions): void {
    sonnerToast.success(message, opts);
  },
  error(message: string, opts?: ToastOptions): void {
    sonnerToast.error(message, opts);
  },
  info(message: string, opts?: ToastOptions): void {
    sonnerToast.info(message, opts);
  },
  warn(message: string, opts?: ToastOptions): void {
    sonnerToast.warning(message, opts);
  },
};

export type ToasterProps = ComponentProps<typeof SonnerToaster>;

/**
 * Mount once at the top of the admin layout. Individual pages don't
 * need to render it.
 */
export function Toaster(props: ToasterProps) {
  return <SonnerToaster {...props} />;
}
